import { TSvgComponentProps } from '../../../types';

/**
 * -----------------------------------------------------------------------------
 * This is the short form of the NorthLadder Buyer app, made uniquely from the
 * NorthLadder logo elements, to be displayed in very tiny spaces on smaller screens.
 */
export function LogoDealerNorthLadderShort(props: TSvgComponentProps) {
  return (
    <svg id="dealer-logo-light" viewBox="0 0 45 24" {...props}>
      <g id="A-NorthCompass">
        <path
          className="fill-indigo-900"
          d="m33.9 3.2 9.8 18.4-10.3-4.7-10.3 4.7L33.4 2.4l.5.8zm-.4 1.3-8 15 8-3.7V4.5z"
          id="A-Background"
        />
        <path
          className="fill-primary-300"
          clipRule="evenodd"
          d="M33.5 15.8V4.5l-8 15 8-3.7z"
          fillRule="evenodd"
          id="A-Highlight"
        />
      </g>
      <path
        className="fill-indigo-900"
        d="M8.4 3.3H1.6v17.3h6.8c6.1 0 8.7-4.4 8.7-8.8-.2-4.3-2.8-8.5-8.7-8.5zM4.8 6.4h3.6c3.8 0 5.3 2.7 5.4 5.4.1 2.8-1.5 5.6-5.4 5.6H4.8v-11z"
        id="D1"
      />
    </svg>
  );
}
